import React from 'react';
import cs from 'classnames';
import UserJobBanner from '~/components/common/UserJobBanner';

import sharedCSS from '~/components/shared.css';
import css from './index.css';


const JobNamePage = () => (
  <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, sharedCSS.unpadded, css.main)}>
    <UserJobBanner redirectTo={'/'}/>
  </div>
);

export default JobNamePage;



// WEBPACK FOOTER //
// ./src/components/pages/JobName/index.js